import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faDiceThree,
    faCheck,
    faCircle,
    faEye,
    faCog,
    faTimes,
    faQuestion,
    faHandshake,
    faTrophy,
    faEquals,
    faPowerOff,
    faNotEqual,
    faUser,
    faUsers,
    faHandshakeSlash,
    faPlusCircle,
    faEdit,
    faSave,
    faAngleRight,
    faAngleLeft,
    faGripLinesVertical,
    faAngleDown,
    faAngleUp,
    faAngleDoubleUp,
} from '@fortawesome/free-solid-svg-icons';

library.add(faDiceThree);
library.add(faCheck);
library.add(faCircle);
library.add(faEye);
library.add(faCog);
library.add(faTimes);
library.add(faQuestion);
library.add(faHandshake);
library.add(faHandshakeSlash);
library.add(faTrophy);
library.add(faEquals);
library.add(faPowerOff);
library.add(faNotEqual);
library.add(faUser);
library.add(faUsers);
library.add(faPlusCircle);
library.add(faEdit);
library.add(faSave);
library.add(faAngleRight);
library.add(faAngleLeft);
library.add(faGripLinesVertical);
library.add(faAngleDown);
library.add(faAngleUp);
library.add(faAngleDoubleUp);
